import FilterAltOutlinedIcon from "@mui/icons-material/FilterAltOutlined";
import React, { useRef } from "react";
import { Box } from "@mui/material";
import { DashboardCardTitle } from "../DashboardCard/DashboardCardTitle";
import * as Styled from "./DashboardChart.styles";
import { Translations } from "ui/Scripts/source/models/translations";
import { DashboardCardProgress } from "../DashboardCard/DashboardCardProgress";
import { IDashboardChartData } from "source/models/report/dashboardChartData";
import { BarChart } from "../Chart/BarChart";
import { PieChart } from "../Chart/PieChart";
import { Base } from "ui/Scripts/source/framework/base";
import { AppChartType } from "ui/Scripts/source/models/enums";
import { LineChart } from "../Chart/LineChart";

interface IDashboardChartProps {
    panelId: string;
    title: string;
    chartData: IDashboardChartData;
    isLoading: boolean;
    onShowProperties: (panelId: string) => void;
}

export const DashboardChart = (props: IDashboardChartProps) => {
    const legendContainerId = useRef(Base.getGuid());

    return (
        <div style={{ height: "100%" }}>
            <Box display="flex" justifyContent="space-between" alignItems="start">
                <DashboardCardTitle
                    title={props.title}
                />
                {!!props.onShowProperties &&
                    <Styled.FilterButton
                        variant="text"
                        onClick={() => props.onShowProperties(props.panelId)}
                        endIcon={<FilterAltOutlinedIcon />}
                    >
                        {Translations.Filters}
                    </Styled.FilterButton>
                }
            </Box>
            <Styled.Container>
                <DashboardCardProgress isLoading={props.isLoading} />
                {!props.isLoading && !!props.chartData &&
                    <Box sx={{ width: "100%", height: "100%", position: "relative", padding: "0 1rem 1rem 1rem", display: "flex" }}>
                        <Box sx={{ width: "70%", flexGrow: "1" }}>
                            {(props.chartData.chartType === AppChartType.BarChart
                                ? <BarChart
                                    title={props.chartData.title}
                                    dataId={props.chartData.dataId}
                                    labels={props.chartData.labels}
                                    dataSets={props.chartData.dataSets}
                                    legendContainerId={legendContainerId.current}
                                    yAxisValueFormatting={props.chartData.yAxisValueFormatting}
                                />
                                : props.chartData.chartType === AppChartType.PieChart
                                    ? <PieChart
                                        title={props.chartData.title}
                                        dataId={props.chartData.dataId}
                                        labels={props.chartData.labels}
                                        dataSets={props.chartData.dataSets}
                                        legendContainerId={legendContainerId.current}
                                    />
                                    : <LineChart
                                        title={props.chartData.title}
                                        dataId={props.chartData.dataId}
                                        labels={props.chartData.labels}
                                        dataSets={props.chartData.dataSets}
                                        legendContainerId={legendContainerId.current}
                                        yAxisValueFormatting={props.chartData.yAxisValueFormatting}
                                    />
                            )}
                        </Box>
                        <Box id={legendContainerId.current} sx={{ width: "30%", maxWidth: "200px", height: "100%", overflowY: "auto", overflowX: "hidden" }}> </Box>
                    </Box>
                }
            </Styled.Container>
        </div>
    );
};
